import axios from "axios";
import qs from "qs";
import { api } from "@/plugins/util";

export function getParam({mark},pageNum) {
    return axios.get(api + "/sysParam/list", {
        params : {
            mark,
            pageNum
        }

    });
}

export function getParamByMark(mark) {
    return axios.get(api + "/sysParam/select", {
        params : {
            mark
        }

    });
}

export function getAllTree() {
    return axios.get(api + "/sysParam/getTree", qs.stringify({

        })

    );
}

export function addSysParam({param,mark,desc,sort}) {
    return axios.post(api + "/sysParam/add", qs.stringify({
            param,
            desc,
            mark,
            sort
        })

    );
}

export function updateSysParam({id,param,desc,sort}) {
    return axios.post(api + "/sysParam/update", qs.stringify({
            id,
            param,
            desc,
            sort
        })

    );
}

export function deleteById(id) {
    return axios.post(api + "/sysParam/delete", qs.stringify({
            id
        })

    );
}
